import React from 'react';
import { Button } from 'reactstrap';
import "../../stylesheets/JDIntegrationButton.css"


const JohnDeereButton = ({ onClick }) => (
  <Button color="success" onClick={onClick}>
    Integrate with John Deere
  </Button>
);

export default JohnDeereButton;



// WEBPACK FOOTER //
// ./src/components/ui/JDIntegrationButton.js